export const TASKCATEGORY_TYPES = 'taskCategoryTypes';
export const TASKCATEGORY_TYPES_COUNT = 'taskCategoryTypesCount';
export const TASKCATEGORY_TYPES_LOADING = 'taskCategoryTypesLoading';

